import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { getThoughts } from '../services/thoughtService';

/**
 * Fetch ALL of the user's thoughts (not just drafts).
 *
 * The home page loads a drafts-only array for the inbox, but a few views need
 * the full corpus: Timeline (chronological calendar), Shuffle (random over all
 * thoughts), and StarField (filters by the "Starfield" tag — which are triaged,
 * so never in the drafts array). Those views call this hook so they get every
 * thought. The fetch is lazy (on mount of the view), so the home page never
 * pays the cost of the full load.
 *
 * @returns {{ thoughts: Array, loading: boolean }}
 */
const useAllThoughts = () => {
  const [thoughts, setThoughts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.user) {
          if (!cancelled) { setThoughts([]); setLoading(false); }
          return;
        }
        const rows = await getThoughts(session.user.id);
        if (!cancelled) { setThoughts(rows); setLoading(false); }
      } catch (error) {
        console.error('Error fetching all thoughts:', error);
        if (!cancelled) { setThoughts([]); setLoading(false); }
      }
    })();

    return () => { cancelled = true; };
  }, []);

  return { thoughts, loading };
};

export default useAllThoughts;
